/**
 * @desc 申请SN码
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierSnBatch.applySnCode.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierSnBatch/applyBoxCode`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
